import {
  GET_MENU_DONE,
  IS_CREATING_MENU,
  IS_DELETING_MENU,
  IS_GETTING_MENU,
  IS_UPDATING_MENU,
  SET_MENU_DONE,
} from './constants';

export default {
  [GET_MENU_DONE](state, menu) {
    state.rawMenu = menu;
  },
  [IS_CREATING_MENU](state, creating) {
    state.isCreatingMenu = creating;
  },
  [IS_DELETING_MENU](state, deleting) {
    state.isDeletingMenu = deleting;
  },
  [IS_GETTING_MENU](state, getting) {
    state.isGettingMenu = getting;
  },
  [IS_UPDATING_MENU](state, updating) {
    state.isUpdatingMenu = updating;
  },
  [SET_MENU_DONE](state, menu) {
    state.menu = menu;
  },
};
